@if (!claimsEnterpriseApp) {
  <div class="report-claim column twelve lg-eight lg-push-two md-eight md-push-two">
    <h4
      class="heading-sub-section"
      dsContent
      [contentPath]="'claims.fnol.riskSelectionCompSubHeading'"
      data-cy="riskSelectionCompSubHeading"
    ></h4>
    <p
      class="pad-top-10"
      dsContent
      [contentPath]="'claims.fnol.riskSelectionCompText'"
      data-cy="riskSelectionCompText"
    ></p>
    <p class="pad-top-10">
      <span
        dsContent
        [contentPath]="'claims.fnol.privacyAndSecurityPre'"
        data-cy="privacyAndSecurityPre"
      ></span>
      <a [dsRouterLink]="['/privacy-security-policy']">
        <span
          dsContent
          [contentPath]="'claims.fnol.privacyAndSecurityURL'"
          data-cy="privacyAndSecurityURL"
        ></span
      ></a>
      <span
        dsContent
        [contentPath]="'claims.fnol.privacyAndSecurityPost'"
        data-cy="privacyAndSecurityPost"
      ></span>
    </p>
    <form [formGroup]="riskSelectionForm" (ngSubmit)="riskSelectionSubmit()">
      <!-- The data has not come back yet -->
      @if (dataLoading | async) {
        <ds-localized-spinner
          class="block pad-bottom-20"
          [dataLoading]="dataLoading | async"
          [loadingMessage]="'Looking for risks...'"
        ></ds-localized-spinner>
      }
      @if ((dataLoading | async) === false) {
        <div>
          <h4
            dsContent
            [contentPath]="'claims.fnol.riskSelectionHeading'"
            data-cy="riskSelectionHeading"
          ></h4>
          <div class="row pad-bottom-10">
            <fieldset>
              <ds-risk-list
                [risks]="risks"
                [preSelectedRisk]="preSelectedRisk"
                [otherContent]="otherText"
                (riskChange)="changeRisk($event)"
              >
              </ds-risk-list>
            </fieldset>
          </div>
        </div>
      }
      <div class="row callToAction">
        <span class="md-float-right">
          <a
            class="pad-horizontal-20"
            (click)="cancel()"
            dsContent
            [contentPath]="'shared.cancel'"
            tabindex="0"
          ></a>
          <button
            ds-button
            type="submit"
            [disabled]="
              !currentRisk ||
              (roleService.isAuthorized('fnolform_walkthrough') | async) === false ||
              (roleService.isAuthorized('rptclmfrm_walkthrough') | async) === false
            "
            data-cy="primaryButton"
            dsContent
            [contentPath]="'shared.nextBtn'"
            data-cy="primaryButton"
          ></button>
        </span>
      </div>
    </form>
  </div>
}
